import { createLogic } from "redux-logic";
import * as Action from "./action";
import * as Types from "./types";
import _ from "lodash";
import debugLog, {LogLevel} from "../utils/debugLog";

const updateSegmentsLogic = createLogic({
  type: Types.GET_BUS_ETA,
  warnTimeout: 0,
  processOptions: {
    dispatchMultiple: true,
  },
  async process({ action, httpClient, getState }: any, dispatch, done) {
    const { callback } = action.payload;
    let allRouteLocation: any[] = [];

    try {
      const routes = await httpClient.get(
        `${process.env.REACT_APP_SERVER_URL}/api/Routes?Filter={"TenantId": 4}`
      );

      if (routes) {
        const ids = _.map(routes.data, "id");

        //populate all routeLocations from many routes
        await Promise.all(
          ids.map(async (id) => {
            const routesRes = await httpClient.get(
              `${process.env.REACT_APP_SERVER_URL}/api/routes/${id}`
            );
            if (routesRes) {
              allRouteLocation = [
                ...allRouteLocation,
                ...routesRes.data.routeLocations,
              ];
            }
          })
        );

        let locationIds = _.uniq(_.map(allRouteLocation, "locationId"));
        let allLocations: any[] = [];
        await Promise.all(
          locationIds.map(async (id) => {
            const locationRes = await httpClient.get(
              `${process.env.REACT_APP_SERVER_URL}/api/locations/${id}`
            );
            if (locationRes) {
              allLocations = [...allLocations, locationRes.data];
            }
          })
        );

        // console.log("All Locations", allLocations);
        dispatch(
          Action.updateLocationList(_.orderBy(allLocations, "id", "asc"))
        );

        let etaByVehicle: any[] = [];

        //filter all route location, select only item that has vehicle eta on it
        const notEmptyVehicleEtas = _.filter(allRouteLocation, (item: any) => {
          return item.vehicleEtas.length !== 0;
        });

        //populate all vehicle eta
        notEmptyVehicleEtas.forEach((item: any) => {
          etaByVehicle = [...etaByVehicle, ...item.vehicleEtas];
        });

        dispatch(Action.getBusEtaSuccess(etaByVehicle));
        if (callback) callback(ids);
      }

      // setRouteIds(ids);
    } catch (error) {
      debugLog(LogLevel.ERROR, 'Unable to get `updateSegmentsLogic()`. ', {
          error: error,
      });
    }

    done();
  },
});

export default [updateSegmentsLogic];
